import styled from 'styled-components';

export const BoxTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px 16px;
  margin-bottom: 24px;

  .is-multi {
    counter-increment: alphabetic;

    &::after {
      content: ' ' counter(alphabetic, upper-alpha);
    }
  }

  @media ${(props) => props.theme.device.mobileL} {
    flex-wrap: wrap;

    button {
      order: 2;
    }

    .confirmed {
      width: 100%;
      order: 3;
    }
  }
`;

export const ActivityDetails = styled.div`
  margin-top: 40px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  row-gap: 40px;

  &.first {
    margin-top: unset;
  }

  .stretch.two {
    grid-column-end: span 2;
  }
  .stretch.three {
    grid-column-end: span 3;
  }

  @media ${(props) => props.theme.device.tabletL} {
    max-width: 100%;
  }

  @media ${(props) => props.theme.device.mobileL} {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }
`;

export const ModelWrapper = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 24px;
`;
